<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div class="d-flex justify-content-between">
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Editar Administrador
                    </h3>
                    <div class="">
                      <button
                        class="mt-2 btn-sm bg-primary text-white font-weight-normal border btn-outline-primary h5 btn d-flex flex-nowrap align-items-center"
                        @click.prevent="returnUrl"
                      >
                        <i class="bi bi-arrow-left mr-1"></i>
                        Volver
                      </button>
                    </div>
                  </div>
                  <form>
                    <div class="row">
                      <div class="col-12 col-sm-4 pl-0">
                        <div
                          class="col-xl-12 col-md-10 col-12 d-flex justify-content-center align-items-center m-auto"
                        >
                          <img
                            v-if="form.url_image"
                            :src="form.url_image"
                            class="mb-4 bg-light d-flex justify-content-center align-items-center border w-75 rounded-lg shadow-sm"
                          />
                          <img
                            v-else
                            src="@/assets/img/company_logo.png"
                            class="mb-4 bg-light d-flex justify-content-center align-items-center border w-75 rounded-lg shadow-sm"
                          />
                        </div>
                        <div id="app">
                          <file-pond
                            name="test"
                            ref="filePond"
                            label-idle="Agrega la imagen aquí"
                            v-bind:allow-multiple="false"
                            accepted-file-types="image/jpeg, image/png"
                            :server="null"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-8 px-0 pl-3">
                        <div class="row">
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0">
                            <label for="">Nombre</label>
                            <input
                              type="text"
                              placeholder="Nombre"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.first_name"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                            <label for="">Apellido</label>
                            <input
                              type="text"
                              placeholder="Apellido"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.last_name"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0">
                            <label for="">Teléfono</label>
                            <input
                              type="text"
                              placeholder="Teléfono"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.phone_1"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                            <label for="">Correo</label>
                            <input
                              type="text"
                              placeholder="Correo"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.email"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pr-md-2 pl-0 pr-0 py-0">
                            <label for="">Rol</label>
                            <Multiselect
                              v-model="form.id_role"
                              :options="roles"
                              label="role"
                              :show-labels="false"
                              placeholder="Seleccione un rol"
                              id="typeStatus"
                            ></Multiselect>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="d-flex justify-content-end w-100">
                        <button
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                          @click.prevent="updateElement"
                        >
                          Modificar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="row">
              <div class="col-12">
                <div class="col-12 py-3 px-4 pt-4">
                  <h3
                    class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                  >
                    Contraseña
                  </h3>
                  <div class="row">
                    <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0 mb-2">
                      <label for="">Contraseña</label>
                      <input
                        type="password"
                        placeholder="Contraseña"
                        class="form-control form-control-sm mt-1 mb-2"
                        v-model="form.password"
                        required
                      />
                    </div>
                    <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                      <label for="">Confirmar contraseña</label>
                      <input
                        type="password"
                        placeholder="Confirmar contraseña"
                        class="form-control form-control-sm mt-1 mb-2"
                        v-model="form.confirm_password"
                        required
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-end w-100">
                    <button
                      class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                      style="width: 190px"
                      @click.prevent="updatePassword()"
                    >
                      Modificar Contraseña
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

// Import MultiSelect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  data() {
    return {
      form: {
        url_image: '',
        first_name: '',
        last_name: '',
        phone_1: '',
        email: '',
        id_role: '',
        password: '',
        confirm_password: ''
      },
      roles: [],
      showPassword: false,
      showConfirmPassword: false
    }
  },
  components: {
    FilePond,
    Multiselect
  },
  methods: {
    ...mapActions(['getData', 'updateData', 'optimizeImage']),

    handleFileAdd(file) {
      this.form.url_image = file.file
    },

    handleFileRemove(file) {
      this.form.url_image = []
    },
    loadRoles() {
      this.getData({ url: 'role/all' })
        .then((response) => {
          this.roles = response.data.map((role) => {
            return {
              id: role.id,
              role: role.name
            }
          })
        })
        .catch((error) => {
          console.error(error)
          Swal.fire('Error', 'No se pudo cargar los roles.', 'error')
        })
    },

    getElement(id) {
      this.getData({ url: `admin/${id}` })
        .then((response) => {
          // Asignar los datos del administrador
          this.form = {
            ...response.data
          }

          // Buscar el rol correspondiente en el array de roles
          const selectedRole = this.roles.find(
            (role) => role.id === this.form.id_role
          )
          if (selectedRole) {
            this.form.id_role = selectedRole // Asigna el objeto completo
          }
        })
        .catch((error) => {
          console.error(error)
          Swal.fire('Error', 'No se pudo cargar el administrador.', 'error')
        })
    },
    updateElement() {
      if (
        this.form.first_name === '' ||
        this.form.last_name === '' ||
        this.form.phone_1 === '' ||
        this.form.email === '' ||
        this.form.id_role === ''
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete todos los campos para continuar.',
          icon: 'warning',
          confirmButtonText: 'Aceptar'
        })
        return
      }

      // Confirmar antes de guardar
      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar los cambios?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, Guardar'
      }).then(async (result) => {
        if (result.value) {
          const formData = new FormData()
          formData.append('first_name', this.form.first_name)
          formData.append('last_name', this.form.last_name)
          formData.append('phone_1', this.form.phone_1)
          formData.append('email', this.form.email)
          formData.append('id_role', this.form.id_role.id)
          const filePondInstance = this.$refs.filePond.getFiles()
          if (filePondInstance.length > 0 && filePondInstance[0].file) {
            const compressedImage = await this.optimizeImage(
              filePondInstance[0]
            )
            formData.append('url_image', compressedImage)
          }
          formData.append('url_image', [0])
          const form = {
            url: 'admin/update',
            id: this.form.id,
            data: formData
          }

          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Administrador modificado correctamente',
                  icon: 'success',
                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  this.returnUrl()
                })
              } else if (response.code === 409) {
                Swal.fire({
                  title: 'Error',
                  text: 'Ya existe un administrador con ese correo electrónico.',
                  icon: 'error',
                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },

    updatePassword() {
      // Validar que las contraseñas coincidan
      if (this.form.password !== this.form.confirm_password) {
        Swal.fire({
          title: 'Error',
          text: 'Las contraseñas no coinciden. Por favor, inténtalo de nuevo.',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
        return
      }

      if (this.form.password === '') {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, ingresa una nueva contraseña.',
          icon: 'warning',
          confirmButtonText: 'Aceptar'
        })
        return
      }

      // Confirmar antes de modificar la contraseña
      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de modificar la contraseña?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, Modificar'
      }).then((result) => {
        if (result.value) {
          const formData = new FormData()
          formData.append('password', this.form.password)

          const form = {
            url: 'admin/update',
            id: this.form.id,
            data: formData
          }

          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Contraseña modificada correctamente',
                  icon: 'success',
                  confirmButtonText: 'Aceptar'
                })
              } else {
                Swal.fire({
                  title: 'Error',
                  text: 'Ocurrió un error al modificar la contraseña.',
                  icon: 'error',
                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },

    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword
    },

    returnUrl() {
      this.$router.go(-1)
    }
  },

  mounted() {
    this.loadRoles()
    this.getElement(this.$route.params.id)
  }
}
</script>

<style>
.filepond--credits {
  display: none !important;
}
</style>
